import React, { useEffect, useState } from "react";
import { ICONEX } from "src/constants/images";
import { useSelector } from "react-redux";
import { GoInfo } from "react-icons/go";

import * as icon from "services/icon";
import BidModal from "components/Modals/BidModal";
import ChangeNameModal from "components/Modals/ChangeNameModal";
import { ClOSE } from "src/constants/images";
import NameModal from "components/Modals/NameModal";
import SalePriceModal from "components/Modals/SalePriceModal";

import ConnectWalletModal from "components/Modals/ConnectWalletModal";
import ClaimAllModal from "components/Modals/ClaimAllModal";
import { SYMBOL_VALIDATION } from "src/constants/regex";
import { replaceFloatValue } from "utils/replaceFloatValue";
import ApprovalModal from "components/Modals/ApprovalModal";
import BuyPriceModal from "components/Modals/BuyPriceModal";
import ClaimGBETModal from "components/Modals/ClaimGBETModal";
import BuyConfirmModal from "components/Modals/BuyConfirmModal";
import { WALLET_TYPE } from "src/constants/walletType";
import { nFormatter } from "utils/nFormatter";
import TransferNFTModal from "components/Modals/TransferNFTModal";
import { TRANSFER_NFT } from "src/constants/images";
export default function GangstaTransactionCTAs({
  data,
  address,
  changeNameLoading,
  setChangeNameLoading,
  changeNameSuccess,
  setChangeNameSuccess,
  connectLoading,
  setConnectLoading,
  connectSuccess,
  setConnectSuccess,
  onSuccess,
  gbetInWallet,
  salePrice,
  handleSellGangsta,
  handleTransferNFT,
  handleApproval,
  nftData,
  handleBuyingGangsta,
  claimGbet,
  buyConfirm,
  setBuyConfirm,
  _handleRemoveFromList,
  isSalePriceModalVisible,
  setIsSalePriceModalVisible,
  nftId,
  isTransferNFTModalVisible,
  setIsTransferNFTModalVisible,
  currentName,
  setClaimAccmulatedGbet,
  walletType,
  walletPath,
  transport,
  getTxResultWithTimer,
  last_claim_timer,
  fee_cut_rate,
}) {
  const [newName, setNewName] = useState("");
  const [tx, setTx] = useState("");
  const [alert, setAlert] = useState(false);
  const [nameChangeCost, setNameChangeCost] = useState(0);
  const [name, setName] = useState(false);
  const [nameValidation, setNameValidation] = useState("");
  const [approval, setApproval] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  const [claim, setClaim] = useState(false);
  const [isChangenameVisible, setChangeName] = useState(false);
  const [totalsalePrice, setTotalsalePrice] = useState(0);
  const [nftTransferAddress, setNftTransferAddress] = useState("");

  const [nameLoading, setNameLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [accumulatedGbet, setAccumulatedGbet] = useState(0);
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  const { isMarketingApproved } = useSelector((state) => state.wallet);
  const [isSetPriceButtonEnabled, setSetPriceButtonStatus] = useState(false);
  const [isBuyButtonEnabled, setBuyButtonStatus] = useState(false);

  const checkName = async () => {
    setNameLoading(true);
    const res = await icon.verifyUniqueName(newName);

    if (res === 1) {
      setAlertMessage(
        `${newName} already exist. Please try again with another name.`
      );
      setAlert(true);

      setTimeout(() => {
        setAlert("");
      }, 4000);
    } else {
      changeName();
    }
  };
  const changeName = async () => {
    handleNameModalClose();
    if (address && newName.length > 2) {
      setChangeNameSuccess({ status: "loading" });
      setChangeName(false);
      setChangeNameLoading(true);
      const res = await icon.changeName(
        address,
        newName,
        data.token_id.toString(16),
        walletType,
        walletPath,
        transport
      );

      if (WALLET_TYPE.LEDGER == walletType) {
        if (res?.name == "TransportStatusError") {
          setChangeNameSuccess({ status: "cancel" });
        } else if (res) {
          getTxResultWithTimer(res);
        } else {
          setChangeNameSuccess({ status: "error" });
        }
      }
    } else if (!address) {
      setConnectSuccess({ status: "loading" });
      setConnectLoading(true);
      handleLogin();
    } else if (isChangenameVisible && newName.length === 0) {
      setAlertMessage("Please fill-up name field before moving further.");
      setAlert(true);
    } else {
      setChangeName(true);
    }
  };

  const handleLogin = async () => {
    icon.handleLogin();
  };

  useEffect(() => {
    getNftNameChangeCost(data);
    getGbetBalance(nftId);
    icon.getSettingPriceStatus().then((data) => {
      setSetPriceButtonStatus(data == "0x1" ? true : false);
    });
    icon.getBuyingPriceStatus().then((data) => {
      setBuyButtonStatus(data == "0x1" ? true : false);
    });
  }, []);

  const getNftNameChangeCost = async (data) => {
    const cost = await icon.getNftNameChangeCost();

    setNameChangeCost(cost);
  };

  const getGbetBalance = async (nft_id) => {
    const balance = await icon.getGbetBalance(nft_id);

    setAccumulatedGbet(Math.round(balance));
  };

  const handleSellGangstaClick = () => {
    if (isMarketingApproved == "0x1") {
      setIsSalePriceModalVisible(true);
    } else {
      setApproval(true);
    }
    // await icon.setSellingPrice({ address, nft_id: data.token_id, price: 100 });
  };

  const handleTransferNFTClick = () => {
    if (isMarketingApproved == "0x1") {
      // setIsSalePriceModalVisible(true);
      setIsTransferNFTModalVisible(true);
    } else {
      setApproval(true);
    }
  };

  const handleBuyGangsta = () => {
    setBuyConfirm(true);
    // if (isMarketingApproved == "0x1") {
    //   setBuyConfirm(true);
    // } else {
    //   setApproval(true);
    // }
  };

  // const checkSalePrice = (salePrice) => {
  //   if (salePrice > (10 ^ 18)) {
  //     const price = salePrice / (10 ^ 18);

  //     return <>{}</>;
  //   }
  // };

  const checkIfSellisVisible = () => {
    if (address === nftData.owner) {
      return (
        <>
          {isSetPriceButtonEnabled ? (
            <button
              className={"set-sell green-outline"}
              onClick={handleSellGangstaClick}
            >
              {salePrice >= 0 ? "Change Sell Amount" : "Set for Sell"}
            </button>
          ) : (
            <button
              disabled={true}
              className={"set-sell disabled"}
            // onClick={handleSellGangstaClick}
            >
              {salePrice >= 0 ? "Change Sell Amount" : "Set for Sell"}
            </button>
          )}

          {/* {salePrice >= 0 ? null: */}
          {/* <button
              className={"set-sell light mt-1"}
              onClick={handleTransferNFTClick}
            >
              Transfer NFT
            </button> */}

          <span className="custom-tooltip-transfer">
            <span className="tooltiptext">Transfer NFT</span>
            <span className="transfer-nft" onClick={handleTransferNFTClick}>
              <img src={TRANSFER_NFT} />
            </span>
          </span>

          {/* } */}
        </>
      );
    } else if (salePrice !== -1 && address) {
      return (
        <>
          {!isBuyButtonEnabled ? (
            <span className="custom-tooltip  market-info-tooltip">
              <span className="tooltiptext tooltipMarket">
                {" "}
                Buying is temporarily disabled
              </span>
              <button
                disabled={true}
                className={"gp-cta cursor-na  disabled"}
                onClick={handleBuyGangsta}
              >
                Buy
              </button>
            </span>
          ) : (
            <button className={"gp-cta light"} onClick={handleBuyGangsta}>
              Buy
            </button>
          )}
        </>
      );
    }

    return <></>;
  };

  const handleInputChange = (e) => {
    setNewName(e.target.value);
  };

  const handleValidation = () => {
    if (newName == "") {
      setNameValidation("Name field should be above 2 characters.");
    } else if (!SYMBOL_VALIDATION.test(newName)) {
      setNameValidation("");
    } else {
      setNameValidation("Name cannot contain symbols.");
    }
  };

  const handleClose = () => {
    setChangeNameLoading(false);
    setNameValidation("");
    setChangeNameSuccess({ status: "loading" });
    setNewName("");
    if (changeNameSuccess.status === "success") {
      onSuccess();
    }
  };

  const handleWalletClose = () => {
    setConnectLoading(false);
    setConnectSuccess({ status: "loading" });
  };

  const handleApprovalRequest = (status) => {
    setApproval(false);

    if (status == "approval") {
      handleApproval();
    }
  };

  const handleNameModalClose = () => {
    setName(false);
    setNameValidation("");
  };

  // if (address !== nftData.owner && salePrice == -1) {
  //   return <></>;
  // }

  return (
    <>
      <div
        className="gp-gangsta-transaction-container"
        style={{ position: "relative" }}
      >
        {/* left side */}
        <div className="transaction-info">
          {salePrice !== -1 ? (
            <>
              <div className="d-flex price-box">
                <div className="gp-current-price">
                  <p>Current Price </p>
                  <div className="price-info">
                    <div
                      className="d-flex price-ICX-USD"
                      style={{ gap: "10px", paddingRight: "18px" }}
                    >
                      <div className="d-flex price-vals">
                        <div className="price-ICX d-flex mb-2 align-items-baseline">
                          <img src={ICONEX.SOURCE} /> &nbsp;
                          {nFormatter(salePrice)}
                          <div className="unit"> ICX</div>
                        </div>
                        <div className="price-USD d-flex mb-2">
                          (~
                          {`$${nFormatter(
                            replaceFloatValue(salePrice * icxInUSD)
                          )}`}
                          <div className="unit"> USD</div>)
                        </div>
                      </div>

                      <div className="d-flex">
                        <div className="buttons-container">
                          {salePrice >= 0 && address === nftData.owner ? (
                            <button
                              className="set-sell white-text-red mt-3 mb-2"
                              onClick={() => {
                                _handleRemoveFromList(totalsalePrice);
                              }}
                            >
                              Remove From Sell
                            </button>
                          ) : null}
                          {checkIfSellisVisible()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex">
                  <div
                    className="gp-accumulated-gbet d-flex flex-column align-items-start"
                    style={{
                      height: `${address === nftData.owner ? `180px` : "0px"}`,
                    }}
                  >
                    {/* <span className="border-left"> */}

                    <div
                      className="d-flex"
                      style={{ flex: "1", paddingTop: "10px" }}
                    >
                      <p>
                        Accumulated{" "}
                        {/* <span className="custom-tooltip">
                          <span className="tooltiptext">
                            This is some information.
                          </span>
                          <GoInfo
                            color="var(--secondary-color)"
                            className="info-icon"
                          />
                        </span> */}
                      </p>
                    </div>

                    <div
                      className="GBET-val d-flex align-items-baseline"
                      style={{ flex: "2" }}
                    >
                      {accumulatedGbet.toFixed(2)}
                      <div className="unit"> $GBET</div>
                    </div>

                    <div className="d-flex" style={{ flex: "1" }}>
                      {address === nftData.owner ? (
                        replaceFloatValue(accumulatedGbet) > 0 ? (
                          <button
                            className="gp-cta green-outline"
                            style={{ minWidth: "120px" }}
                            onClick={() => setClaim(true)}
                          >
                            Claim
                          </button>
                        ) : (
                          <button
                            className="gp-cta disabled"
                            style={{ minWidth: "120px" }}
                          >
                            Claim
                          </button>
                        )
                      ) : null}
                    </div>
                    {/* </span> */}
                  </div>

                  {salePrice !== -1 && address === nftData.owner ? (
                    <div
                      className="gp-wallet d-flex flex-column align-items-start"
                      style={{ height: "180px" }}
                    >
                      <div
                        className="d-flex"
                        style={{ flex: "1", paddingTop: "10px" }}
                      >
                        <p>Wallet </p>
                      </div>

                      <div
                        className="GBET-val d-flex align-items-baseline"
                        style={{ flex: "2" }}
                      >
                        {gbetInWallet.toFixed(2)}
                        <div className="unit"> $GBET</div>
                      </div>

                      <div
                        className="d-flex flex-column align-items-start"
                        style={{ flex: "1" }}
                      >
                        {address === nftData.owner ? (
                          <>
                            <div
                              className="d-flex next_claim_timer_counter"
                              style={{ marginTop: "-8px" }}
                            >
                              <p>Next Disbursement in </p>
                            </div>

                            <div className="d-flex value">
                              <b>{last_claim_timer?.timeRemaining}</b>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                </div>

                {/* <div className="gp-accumulated-gbet d-flex flex-column align-items-start" style={{ "gap": "28px", "marginLeft": "14px" }}>

              <div className="d-flex">
                <p>Wallet </p>
              </div>

              <div className="d-flex">
                <p className="d-flex quantity">
                  {accumulatedGbet} <div className="unit">$GBET</div>
                </p>
              </div>

              <div className="d-flex flex-column align-items-start">
                {address === nftData.owner ? (
                  <>
                    <div className="d-flex next_claim_timer_counter">
                      <p>Next Disbursement in </p>
                    </div>


                    <div className="d-flex value">{last_claim_timer?.timeRemaining}</div>


                  </>
                ) : null}
              </div>
            </div> */}
              </div>
            </>
          ) : (
            <>
              <div className="d-flex price-box price-box-nfs">
                <div
                  className="gp-current-price d-flex flex-column"
                  style={{ borderBottom: "none", paddingTop: "45px" }}
                >
                  <div
                    className="price-info mt-5 d-flex flex-column"
                    style={{
                      marginTop: "405px !important",
                      alignItems: "flex-start",
                      gap: "20px",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      className="d-flex price-ICX-USD"
                      style={{ gap: "10px", paddingRight: "18px" }}
                    >
                      <div className="d-flex price-vals">
                        {address === nftData.owner ? (
                          <div
                            className="price-ICX d-flex align-items-baseline"
                            style={{ flex: "2", marginTop: "-22%" }}
                          >
                            Not for sale
                          </div>
                        ) : (
                          <div
                            className="price-ICX d-flex align-items-baseline"
                            style={{ flex: "2", marginTop: "-35%" }}
                          >
                            Not for sale
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex sfs-button">
                      <div className="buttons-container">
                        {checkIfSellisVisible()}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex" style={{ position: "relative" }}>
                  <div
                    className="gp-accumulated-gbet d-flex flex-column align-items-start"
                    style={{ minHeight: "160px" }}
                  >
                    <div
                      className="d-flex"
                      style={{ flex: "2", paddingTop: "10px" }}
                    >
                      <p>Accumulated </p>
                    </div>

                    <div
                      className="GBET-val d-flex align-items-baseline"
                      style={{ flex: "2" }}
                    >
                      {accumulatedGbet.toFixed(2)}
                      <div className="unit"> $GBET</div>
                    </div>

                    <div className="d-flex" style={{ flex: "1" }}>
                      {address === nftData.owner ? (
                        <>
                          {replaceFloatValue(accumulatedGbet) > 0 ? (
                            <>
                              <button
                                className="gp-cta green-outline"
                                style={{ minWidth: "120px" }}
                                onClick={() => setClaim(true)}
                              >
                                Claim
                              </button>
                            </>
                          ) : (
                            <button
                              className="gp-cta disabled"
                              style={{ minWidth: "120px" }}
                            >
                              Claim
                            </button>
                          )}
                        </>
                      ) : null}
                    </div>
                  </div>

                  {address === nftData.owner ? (
                    <div
                      className="gp-wallet d-flex flex-column align-items-start"
                      style={{ height: "180px" }}
                    >
                      <div
                        className="d-flex"
                        style={{ flex: "1", paddingTop: "10px" }}
                      >
                        <p>Wallet </p>
                      </div>

                      <div
                        className="GBET-val NFS-val d-flex align-items-baseline"
                        style={{ flex: "2" }}
                      >
                        {gbetInWallet.toFixed(2)}
                        <div className="unit"> $GBET</div>
                      </div>

                      <div
                        className="d-flex flex-column align-items-start"
                        style={{ flex: "1" }}
                      >
                        <div
                          className="d-flex next_claim_timer_counter"
                          style={{ marginTop: "-8px" }}
                        >
                          <p>Next Disbursement in </p>
                        </div>

                        <div className="d-flex value">
                          <b>{last_claim_timer?.timeRemaining}</b>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* <ChangeNameModal
        isVisible={changeNameLoading}
        success={changeNameSuccess}
        onClick={handleClose}
        name={newName}
        nameChangeCost={nameChangeCost}
      /> */}
      {alert && (
        <div
          class="alert alert-warning alert-dismissible fade show"
          role="alert"
        >
          {alertMessage}
          <span className="ms-2 mb-1 close" onClick={() => setAlert(false)}>
            <img src={ClOSE.SOURCE} alt="close" className="mb-0" />
          </span>
        </div>
      )}
      {/* <NameModal
        isVisible={name}
        onChangeName={checkName}
        nameloader={nameLoading}
        nameChangeCost={nameChangeCost}
        onChange={handleInputChange}
        name={newName}
        onClose={handleNameModalClose}
        onBlur={handleValidation}
        nameValidation={nameValidation}
        currentName={currentName}
      /> */}

      <SalePriceModal
        isVisible={isSalePriceModalVisible}
        fee_cut_rate={fee_cut_rate}
        onChange={(e) => {
          setTotalsalePrice(e.target.value);
        }}
        onClose={() => {
          setIsSalePriceModalVisible(false);
          setTotalsalePrice(0);
        }}
        price={Number(totalsalePrice)}
        salePrice={salePrice}
        totalsalePrice={totalsalePrice}
        setPriceHandler={() => handleSellGangsta(totalsalePrice, salePrice)}
      />

      <TransferNFTModal
        isVisible={isTransferNFTModalVisible}
        // fee_cut_rate={fee_cut_rate}
        // onChange={(e) => {
        //   setNftTransferAddress(e.target.value);
        // }}
        address={address}
        setNftTransferAddress={setNftTransferAddress}
        onClose={() => {
          setIsTransferNFTModalVisible(false);
          setNftTransferAddress("");
        }}
        // price={Number(totalsalePrice)}
        // salePrice={salePrice}
        // totalsalePrice={totalsalePrice}
        // setPriceHandler={() => handleSellGangsta(totalsalePrice)}
        setTransferNFTHandler={() => handleTransferNFT(nftTransferAddress)}
      // handleTransferNFT
      />

      <ConnectWalletModal
        isVisible={connectLoading}
        response={connectSuccess}
        onClick={handleWalletClose}
      />
      <ClaimAllModal
        isVisible={claim}
        onCancel={() => setClaim(false)}
        onClaim={claimGbet}
        claimAmount={accumulatedGbet}
      />
      <ApprovalModal
        isVisible={approval}
        modalType={address == nftData?.owner ? "Sell" : "Buy"}
        onClick={handleApprovalRequest}
      />
      <BuyConfirmModal
        isVisible={buyConfirm}
        onConfirm={() => handleBuyingGangsta(salePrice)}
        onCancel={() => setBuyConfirm(false)}
        icxAmount={salePrice}
        name={nftData?.characterName}
      />
    </>
  );
}
